var TECL_TenderSelectSuppliers = {

    // Initialise the page
    Initialise: function() {
        TECL_TenderGeneral.HidePleaseWaitDlg();

        // Default the add supplier from list add icon to disabled
        $("#addSupplier").addClass("linkDisabled");

        TECL_TenderSelectSuppliers.UpdateSelectSuppliersSectionVisibility();

        // Change the highlighting
        $("#ddlSuppliers").change(function() {
            var supplierId = $("#ddlSuppliers").val();
            var supplierName = $("#ddlSuppliers").data("kendoDropDownList").text();

            if (supplierId && supplierName) {
                $("#addSupplier").removeClass("linkDisabled");
            } else {
                $("#addSupplier").addClass("linkDisabled");
            }
        });

        // Update whether the selectSuppliersSection is visible
        $("input[name=SelectSuppliersRadioButtons]").change(function() {
            TECL_TenderSelectSuppliers.UpdateSelectSuppliersSectionVisibility();
        });

        $(".supplierSelectionRadioBtn").click(function() {
            $(this).find(":radio").prop("checked", true);
            TECL_TenderSelectSuppliers.UpdateSelectSuppliersSectionVisibility();
        });

        window.scrollTo(0, 0);

        TECL_TenderGeneral.InitialiseStickySidebar();

        // Update the progress bar
        TECL_TenderGeneral.UpdateProgressBar(2);

        TECL_Master.StopKendoDropDownScrollBug();
    },

    // Update whether the selectSuppliersSection is visible
    UpdateSelectSuppliersSectionVisibility: function() {
        if ($("#edcoSelectSuppliers").prop("checked") == true) {
            //Hide manual supplier entry section
            $("#selectSuppliersSection").addClass("hidden");

            // Hide any existing suppliers that have been selected
            $(".tenderSelectedSupplier").addClass("hidden");

            // Hide the message that there are no manually input suppliers
            $(".tenderSelectedSupplierEmpty").addClass("hidden");

            // Show the message that EdCo will pick the suppliers
            $(".edcoSelectSuppliersSelected").removeClass("hidden");

            // Hide the error message that there are no manually added suppliers
            $("#errSelectedSuppliersMissing").addClass("hidden");

            // Add the 'selected' class to the selected input for visual feedback,
            // and remove from unselected input.
            $("#edcoSelectSuppliers").parents(".supplierSelectionRadioBtn").addClass("selected");
            $("#userSelectSuppliers").parents(".supplierSelectionRadioBtn").removeClass("selected");
        } else {
            // Show the manual supplier entry section
            $("#selectSuppliersSection").removeClass("hidden");

            // Show any existing suppliers that have been selected
            $(".tenderSelectedSupplier").removeClass("hidden");

            // Check if there are any existing selected suppliers,
            // and show/hide the "no suppliers selected" message as appropriate
            if ($(".tenderSelectedSupplier").length == 0) {
                $(".tenderSelectedSupplierEmpty").removeClass("hidden");
            } else {
                $(".tenderSelectedSupplierEmpty").addClass("hidden");
            }

            // Hide the "we will select the suppliers message"
            $(".edcoSelectSuppliersSelected").addClass("hidden");

            $("#userSelectSuppliers").parents(".supplierSelectionRadioBtn").addClass("selected");
            $("#edcoSelectSuppliers").parents(".supplierSelectionRadioBtn").removeClass("selected");
        }

        TECL_TenderGeneral.InitialiseStickySidebar();
    },

    // Continue to the next stage
    ContinueToNextStage: function() {

        var edCoSelectSupplier;
        if ($("#edcoSelectSuppliers").is(":checked")) {
            edCoSelectSupplier = true;
        } else if ($("#userSelectSuppliers").is(":checked")) {
            edCoSelectSupplier = false;
        } else {
            // Should never get here
            edCoSelectSupplier = true;
        }

        if (TECL_TenderSelectSuppliers.ValidatePage(edCoSelectSupplier)) {
            var cacheId = $("#cacheId").val();

            if (TECL_Master.AddLock("ContinueNextStageAdditionalInformation")) {
                TECL_TenderGeneral.DisplayPleaseWaitDlg();

                // Call Server to add the product request to the cache and reload the product request list
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/Tender/ContinueNextStageAdditionalInformation",
                    type: "POST",
                    data: {
                        cacheId: cacheId,
                        edCoSelectSupplier: edCoSelectSupplier
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("ContinueNextStageAdditionalInformation");
                    },
                    success: function(partialViewHtml) {
                        TECL_Master.ClearLock("ContinueNextStageAdditionalInformation");
                        if (partialViewHtml) {
                            $("#tenderPage").html(partialViewHtml);
                        }
                    }
                });
            }
        }
    },

    // Vaidate the page
    ValidatePage: function(edCoSelectSupplier) {
        var noErrors = true;

        $("#errSelectedSuppliersMissing").addClass("hidden");

        if (!edCoSelectSupplier) {
            var listedSuppliers = $("#TenderSelectedSuppliers").find(".tenderSelectedSupplier");

            if (listedSuppliers.length <= 0) {
                noErrors = false;
                $("#errSelectedSuppliersMissing").removeClass("hidden");
            }
        }

        return noErrors;
    },

    // Added a recommended supplier
    AddRecommendedSupplier: function(supplierId, supplierName) {
        TECL_TenderSelectSuppliers.UpdateSelectedSupplierList(true, supplierId, supplierName);
    },

    // Added a listed supplier
    AddListedSupplier: function() {
        var supplierId = $("#ddlSuppliers").val();
        var supplierName = $("#ddlSuppliers").data("kendoDropDownList").text();

        if (supplierId && supplierName) {
            TECL_TenderSelectSuppliers.UpdateSelectedSupplierList(true, supplierId, supplierName);
        }
    },

    // Delete a selected supplier
    DeleteSelectedSupplier: function(supplierId) {
        TECL_TenderSelectSuppliers.UpdateSelectedSupplierList(false, supplierId, "name");
    },

    // Update the list of selected suppliers
    UpdateSelectedSupplierList: function(addSupplier, supplierId, supplierName) {
        var cacheId = $("#cacheId").val();

        if (TECL_Master.AddLock("UpdateSupplierList")) {
            // Call Server to add the product request to the cache and reload the product request list
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/Tender/UpdateSupplierList",
                type: "POST",
                data: {
                    cacheId: cacheId,
                    addSupplier: addSupplier,
                    supplierId: supplierId,
                    supplierName: supplierName
                },
                error: function(exc) {
                    TECL_Master.ClearLock("UpdateSupplierList");
                },
                success: function(partialViewHtml) {
                    TECL_Master.ClearLock("UpdateSupplierList");
                    if (partialViewHtml) {
                        $("#TenderSelectedSuppliers").html(partialViewHtml);
                        $("#errSelectedSuppliersMissing").addClass("hidden");
                        $(".edcoSelectSuppliersSelected").addClass("hidden");

                        // Add and remove recommended suppliers if they have been selected
                        $("#TenderRecommendedSuppliers").find(".recommendedSupplierEntry").each(function() {
                            var recommendedSupplierId = $(this).find("[name='tenderSupplierId']").val();
                            if (supplierId === recommendedSupplierId) {
                                if (addSupplier) {
                                    $(this).addClass("hidden");
                                } else {
                                    $(this).removeClass("hidden");
                                }
                            }
                        });
                    }
                }
            });
        }
    },

    // Added a listed supplier
    ShowCalculationWorkingsDialog: function() {
        $("#tenderRecommendedSuppliersCalcInfoEditDlg").modal("show");
    }

};